import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';
import './style/scss/ReservationCancel.index.scss';

// export interface DataType {
//   data_id: number;
//   schedule_id: number;
//   contents_id: number;
// club_web_show_name: string | null;
// annex_flag: number | null;
// contents_name: string | null;
// reserve_time_label: string | null;
// alternate_label: string | null;
// installed_seats_name: string | null;
// companion: number | null;
// }

interface Props {
  show: boolean;
  // data: DataType;
  isDisabled: boolean;
  handle: () => void;
  err: string | null;
  onHide: () => void;
}

const ReservationCancel: FC<Props> = ({ show, isDisabled, handle, err, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      animation
      className="p-modal-member"
      dialogClassName="p-modal-member__dialog p-modal-member__dialog--width880 p-modal-member__dialog--height-center reservation-cancel-mdl"
      contentClassName="p-modal-member__content"
    >
      {/* <button type="button" className="p-modal__close-button" aria-label="閉じる" /> */}

      {/* <Modal.Header className="p-modal__header" closeButton> */}
      {/* <Modal.Header className="p-modal__header">
        <Modal.Title className="p-modal__title" id="exampleModalLabel">
          予約をキャンセル
          <br className="u-x-sp-only" />
          します
          <br />
          よろしいですか？
        </Modal.Title>
      </Modal.Header> */}

      {/* <Modal.Body className="p-modal__body">
        <p className="p-modal__text">
          一度キャンセルされたご予約は
          <br className="u-sp-only" />
          元に戻すことはできません。
          <br />
          よろしければ「予約をキャンセル」
          <br className="u-sp-only" />
          ボタンを押してください。
        </p>
      </Modal.Body> */}

      {/* <!-- ボタン --> */}
      {/* <div className="p-modal__button-area">
        <button
          type="button"
          className="p-modal__cancel-button c-button c-button--secondary c-button--large"
          onClick={onHide}
        >
          ✕ 閉じる
        </button>
        <button
          type="button"
          className="p-modal__cancel-button c-button c-button--primary c-button--large"
          onClick={handle(data.schedule_id, data.contents_id)}
        >
          予約をキャンセル
        </button>
      </div> */}

      {/* ****************************************************** */}
      {/* <Modal.Header closeButton> */}
      {/*  <Modal.Title>Content Class</Modal.Title> */}
      {/* </Modal.Header> */}

      <Modal.Body className="p-modal-member__body">
        <button type="button" className="p-modal-member__close-button" aria-label="閉じる" onClick={onHide} />

        <div className="p-modal-member__container">
          <div className="p-modal-member__header">
            <div className="p-modal-member__title">
              予約をキャンセル
              <br className="u-sp-only" />
              します
              <br />
              よろしいですか？
            </div>
          </div>

          <div className="p-modal-member__inner p-modal-member__inner--padding-x80 u-gap15">
            {/* <!--  / 説明文 --> */}
            <div className="p-modal-member__text u-pb15">
              一度キャンセルされたご予約は
              <br className="u-sp-only" />
              元に戻すことはできません。
              <br />
              よろしければ「予約をキャンセル」
              <br className="u-sp-only" />
              ボタンを押してください。
            </div>

            {err ? (
              <>
                <div className="p-alert-box">
                  <div className="p-alert-box__inner">
                    <div className="p-alert-box__icon">
                      <img src="/images/icons/icon-alert.svg" alt="画像" className="p-icon p-icon--size20" />
                    </div>
                    <div className="p-alert-box__text">{err}</div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          {/* <!-- ボタン --> */}
          <div className="p-modal-member__button-area">
            <button
              type="button"
              className="c-button--secondary c-button c-button--secondary c-button--large"
              onClick={onHide}
            >
              ✕ 閉じる
            </button>
            <button
              type="button"
              className="c-button--max-width-auto c-button c-button--primary c-button--large"
              onClick={handle}
              disabled={isDisabled}
            >
              {isDisabled ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                </>
              ) : (
                <></>
              )}
              予約をキャンセル
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ReservationCancel;
